import { render, staticRenderFns } from "./Batch.vue?vue&type=template&id=a950fbf6&scoped=true&"
import script from "./Batch.vue?vue&type=script&lang=js&"
export * from "./Batch.vue?vue&type=script&lang=js&"
import style0 from "./Batch.vue?vue&type=style&index=0&id=a950fbf6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a950fbf6",
  null
  
)

export default component.exports